export function formatNumber(value, decimal, autoDecimal = false) {
    // Verifica se o valor é um número e converte valores em notação científica para decimal completo
    let parsedValue = (typeof value === 'number' && value.toString().includes('e'))
        ? Number(value).toFixed(20).replace(/\.?0+$/, '') // Remove zeros à direita
        : value;

    // Se autoDecimal estiver ativado, ajusta o número de casas decimais com base no valor
    if (autoDecimal) {
        const stringValue = parsedValue.toString();
        const decimalPart = stringValue.split('.')[1];

        if (decimal === undefined) {
            decimal = decimalPart ? decimalPart.length : 2;
        } else {
            if (decimalPart) {
                decimal = decimalPart.length < 2 ? 2 : Math.min(decimalPart.length, decimal);
            } else {
                decimal = 2;
            }
        }
    } else {
        // Se autoDecimal não estiver ativado e decimal for indefinido, usa 2 casas decimais
        if (decimal === undefined) {
            decimal = 2;
        }
    }

    // Formata o valor com as configurações definidas
    return Number(parsedValue).toLocaleString("pt-BR", {
        maximumFractionDigits: decimal,
        minimumFractionDigits: decimal
    });
}


export function formatOnlyNumber(number) {
    if (number === null || number === undefined) {
        return number;
    }
    return number.replace(/[^\d]+/g, '');
}

/**
 * Formata um valor numérico como moeda BRL com prefixo "R$".
 * Usa `formatNumber` e trata nulos/indefinidos como 0.
 */
export const formatCurrencyBRL = (value, d = 2) => `R$ ${formatNumber(value ?? 0, d)}`;

/**
 * Formata um valor numérico como percentual com sufixo "%".
 * Usa `formatNumber` e trata nulos/indefinidos como 0.
 */
export const formatPercentage = (value, d = 2) => `${formatNumber(value ?? 0, d)}%`;

/**
 * Garante uma string segura para UI.
 * Retorna `fallback` quando o valor é nulo ou string vazia.
 */
export const formatToString = (value, fallback = '—') =>
  value == null || value === '' ? fallback : String(value);

/**
 * Normaliza e arredonda um valor monetário para 2 casas decimais.
 * - Converte o valor recebido em número (parseFloat).
 * - Multiplica por 100 e divide novamente para garantir arredondamento correto.
 * - Valores falsy (null, undefined, string vazia) são tratados como 0.
 * - Retorna 0 quando o resultado for exatamente zero.
 *
 * normalizeMoneyValue("123.456") // 123.46
 * normalizeMoneyValue(10.1)      // 10.1
 * normalizeMoneyValue(null)      // 0
 */
export function normalizeMoneyValue(value) {
  const rounded = Math.round(parseFloat(value || 0) * 100) / 100;
  return rounded === 0 ? 0 : rounded;
}